<template>
  <div class="rt-dynamic-form-item-container">
    <div
      ref="rtDynamicItem"
      class="rt-dynamic-form-item"
    >
      <div class="rt-dynamic-input-contain">
        <div
          v-for="(item,index) in valueArr"
          :key="item._id"
          :ref="item._id"
          class="rt-dynamic-input-item"
          :class="index === 0? '': 'rt-dynamic_no_show_label'"
        >
          <slot
            :row="item"
            :index="index"
            :removeMethed="removeItem"
          >
            <rt-form-item
              :label="!index? label:''"
              :class="!index?'rt-form-item__empty-right':''"
              :label-width="labelWidth"
              v-bind="$attrs"
            >
              <rt-input
                v-model="item.value"
                :placeholder="$tx('请输入', 'xpc.form.pleaseEnter')"
              />
              <template v-slot:labelOuterSide>
                <rt-button
                  v-if="!!index"
                  :icon-name="deleteBtnIcon"
                  icon-size="24"
                  :type="deleteBtnType"
                  text
                  @click.native="removeItem(item._id)"
                >
                </rt-button>
              </template>
            </rt-form-item>
          </slot>
        </div>
      </div>
    </div>
    <!-- 添加按钮 -->
    <rt-form-item
      :label-width="labelWidth"
      v-bind="$attrs"
      class="rt-dynamic-add-btn-contain"
    >
      <div
        class="input-add-btn"
        @click="addItem"
      >
        <rt-detail-button
          v-if="addBtnType === 'detail'"
          :type="addBtnType"
          :prefix-icon="addBtnIcon"
        >
          {{ addBtnText }}
        </rt-detail-button>
        <rt-button
          v-else
          :type="addBtnType"
          :icon-name="addBtnIcon"
        >
          {{ $tx(addBtnText, 'xpc.form.addFormItem') }}
        </rt-button>
      </div>
    </rt-form-item>
  </div>
</template>
<script>
export default {
  name: 'RtDynamicFormItem',
  props: {
    // v-model 绑定数据
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    // 限制添加最大值
    maxItem: {
      type: Number,
      default: 5
    },
    // 限制最小值
    minItem: {
      type: Number,
      default: 1
    },

    // 增加按钮属性样式
    addBtnType: {
      type: String,
      default: 'detail'
    },
    addBtnText: {
      type: String,
      default () {
        return this.$tx('新增表单项', 'xpc.form.addFormItem')
      }
    },
    addBtnIcon: {
      type: String,
      default: 'rt-base-plus'
    },
    // 删除按钮属性样式
    deleteBtnType: {
      type: String,
      default: 'default'
    },
    deleteBtnIcon: {
      type: String,
      default: 'rt-base-circle-minus-lined'
    }
  },

  data () {
    return {
      valueArr: [],
      labelWidth: 'auto'
    }
  },

  watch: {
    // 更新绑定数据
    valueArr: {
      handler (val) {
        const data = val.map(item => {
          return item.value;
        });
        this.$emit('input', data);
      },
      deep: true
    }
  },

  mounted () {
    this.valueArr = (this.value.length > 0 ? this.value : [...Array(this.minItem).fill('')]).map(item => {
      return {
        _id: rt.newUUID(),
        value: item
      }
    })
    this.$nextTick(() => {
      const label = this.$refs.rtDynamicItem.getElementsByClassName('el-form-item__label')[0]
      this.labelWidth = `${label.clientWidth}`
    })
  },

  methods: {
    addItem (e) {
      if (this.valueArr.length >= this.maxItem) return;
      const _id = rt.newUUID();
      this.valueArr.push({
        _id,
        value: ''
      });
      this.$nextTick(() => {
        this.$refs[_id][0].style.height = 0;
        const dynamicDom = this.$refs.rtDynamicItem.getElementsByClassName('rt-dynamic-input-item')[0]
        const alignTop = this.isOnLabelTop(e, 'el-form--label-top')
        this.$setTimeout(() => {
          this.$refs[_id][0].style.height =
            (dynamicDom.clientHeight - (alignTop ? dynamicDom.getElementsByClassName('el-form-item__label')[0].clientHeight - 8 : 0)) + 'px';
        }, 0);
      });
    },
    removeItem (_id) {
      if (this.valueArr.length <= 1) return
      this.$refs[_id][0].style.height = 0;
      this.$refs[_id][0].style.opacity = 0;
      this.$setTimeout(() => {
        const index = this.valueArr.findIndex(item => item._id === _id);
        this.valueArr.splice(index, 1);
      }, 300);
    },

    isOnLabelTop (e, className) {
      const paths = e.path
      const path = paths.filter(item => {
        return item.className && item.className.indexOf(className) !== -1
      })
      return !!path.length
    }
  }

}
</script>



// WEBPACK FOOTER //
// rtDynamicFormItem.vue?0f89cfe5